/* @flow */

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'preact-redux';
import { type PreactAppStore } from './types';
import getStore from './get-store';

const renderMain = () => {
    const preactApp = document.getElementById('preact-app');
    if (!preactApp) {
        return;
    }

    const storage = JSON.parse(localStorage.getItem('preact-app-state'));

    if (!storage || !storage.usuario) {
        window.location.replace('https://hml.app.plom.com.br/login');
    }

    const store: PreactAppStore = getStore();
    import('./Main')
        .then(module => module.default)
        .then(Main => render(<Provider store={store}><Main /></Provider>, preactApp));
};

export default renderMain;
